import React, { useState } from 'react';

import { PLAYBOOK_VIEW_TYPE } from '../../../../../constants/playbooks';

import Tag from '../../../../../design-system/Tag/Tag';
import EditLineIcon from '../../../../../design-system/Icons/EditLineIcon';
import DeletePlaybookView from '../DeletePlaybookView/DeletePlaybookView';
import PlaybookViewSidePanel from '../PlaybookViewSidePanel/PlaybookViewSidePanel';
import { ButtonIcon, Toggle } from '../../../../../design-system';
import { DeleteBin4LineIcon } from '../../../../../design-system/Icons';

const PlaybookViewCard = ({ view, playbookId, setViews, makeViewDefault, onDeleteSuccess }) => {
    const { id, name, description, is_default, view_type } = view;

    const isEditable = view_type !== PLAYBOOK_VIEW_TYPE.blocks;

    const [actionModal, setActionModal] = useState({ action: null });

    const renderBadge = () => {
        return (
            <Tag
                text={view_type}
                uppercase
                type="ghost"
                customClassName="border-neutral-400 text-neutral-500 leading-[135%] !font-body-medium !font-medium"
            />
        );
    };

    const handleToggleChange = async () => {
        if (is_default) return;

        await makeViewDefault(id);
    };

    const buttonState = isEditable ? 'default' : 'disabled';

    const closeActionModal = () => setActionModal({ action: null });

    return (
        <div className="px-4 py-3 rounded-2 border-1 border-neutral-200 flex flex-col-reverse min-[520px]:flex-row min-[520px]:items-center min-[520px]:justify-between gap-y-2 gap-x-3 md:gap-x-4">
            <div className="flex items-center gap-3 overflow-hidden">
                <Toggle
                    isSelected={is_default}
                    name="is_default"
                    onChange={handleToggleChange}
                    size="sm"
                />

                <div className="overflow-hidden">
                    <p className="flex items-center font-body-bold text-body-bold-s text-neutral-500">
                        {name}
                    </p>
                    <p className="font-body text-body-regular-xs text-neutral-500 truncate">
                        {description}
                    </p>
                </div>
            </div>

            <div className="flex items-center justify-between md:justify-end gap-2 lg:gap-4">
                {renderBadge()}

                <div className="flex items-center gap-2">
                    <ButtonIcon
                        type="link"
                        size="xs"
                        icon={EditLineIcon}
                        state={buttonState}
                        onClick={() => setActionModal({ action: 'edit' })}
                    />
                    <ButtonIcon
                        type="link"
                        size="xs"
                        icon={DeleteBin4LineIcon}
                        state={buttonState}
                        onClick={() => setActionModal({ action: 'delete' })}
                    />
                </div>
            </div>

            {actionModal.action === 'edit' && (
                <PlaybookViewSidePanel
                    mode="edit"
                    data={view}
                    playbookId={playbookId}
                    setViews={setViews}
                    onClose={closeActionModal}
                />
            )}

            {actionModal.action === 'delete' && (
                <DeletePlaybookView
                    id={id}
                    name={name}
                    isDefault={is_default}
                    setViews={setViews}
                    onDeleteSuccess={onDeleteSuccess}
                    onClose={closeActionModal}
                />
            )}
        </div>
    );
};

export default PlaybookViewCard;
